export const formatTreatmentSignupLabel = (label: string) =>
  label.replace(/\b(?!of\b|de\b)\p{L}/giu, character => character.toLocaleUpperCase());
